import React from 'react';
import { RefreshCw } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Input } from './input';
import { Button } from './button';

interface DisplayNameInputProps {
  value: string;
  onChange: (value: string) => void;
  onResetToAuto?: () => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  className?: string;
}

const DisplayNameInput: React.FC<DisplayNameInputProps> = ({
  value,
  onChange,
  onResetToAuto,
  placeholder = "Auto-generated display name",
  disabled = false,
  error,
  className,
}) => {
  return (
    <div className={cn("space-y-2", className)}>
      <div className="flex gap-2">
        <Input
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={cn(
            "flex-1 bg-[#f0f0f0] text-[#444444] border-[#c4c4c4]",
            error && "border-red-500 focus-visible:ring-red-500"
          )}
        />
        {onResetToAuto && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={onResetToAuto}
            disabled={disabled}
            className="px-3"
            title="Reset to auto-generated name"
          >
            <RefreshCw className="h-4 w-4" />
          </Button>
        )}
      </div>
      {error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default DisplayNameInput;
